import { getIvaRateVenta } from '../../../utils/getIvaRateVenta';

const normalizarTipoIvaDisplay = (tipoIva?: string | null): string => {
  const tipo = String(tipoIva ?? '').trim().toUpperCase();
  if (tipo === 'CF') return 'C';
  if (tipo === 'NI') return 'N';
  if (tipo === 'EX') return 'E';
  return tipo;
};

const TIPOS_IVA_PRECIOS_CON_IVA = new Set(['C', 'N', 'E']);

export const round2 = (value: number): number => Math.round(value * 100) / 100;

export const esTipoIvaPreciosConIva = (tipoIva?: string | null): boolean => {
  const tipo = normalizarTipoIvaDisplay(tipoIva);
  return TIPOS_IVA_PRECIOS_CON_IVA.has(tipo);
};

export const multiplicadorIvaProducto = (producto: unknown, tipoIva?: string | null): number => {
  const ivaRate = getIvaRateVenta(producto, normalizarTipoIvaDisplay(tipoIva));
  return 1 + (Number.isFinite(ivaRate) && ivaRate > 0 ? ivaRate : 0);
};

export const aPrecioDisplay = (precioNeto: number, multiplicador: number): number => {
  const precio = Number(precioNeto) || 0;
  const mult = Number(multiplicador) > 0 ? Number(multiplicador) : 1;
  return round2(precio * mult);
};

export const aPrecioNeto = (precioDisplay: number, multiplicador: number): number => {
  const precio = Number(precioDisplay) || 0;
  const mult = Number(multiplicador) > 0 ? Number(multiplicador) : 1;
  return round2(precio / mult);
};

export const subtotalLineaDisplay = (subtotalNeto: number, multiplicador: number): number =>
  aPrecioDisplay(subtotalNeto, multiplicador);
